
import { computed, defineComponent, reactive, ref, watch, watchEffect } from 'vue';
export default defineComponent({
    name: 'App',
    watch: {
        surnam: {
            handler(v) {
                console.log(v);
            }
        }
    },
    setup() {
        const user = reactive({
            surnam: 'a',
            name: 'bc',
        })

        // 计算属性
        const fullName1 = computed(() => {
            return user.surnam + '_' + user.name;
        });

        const fullName2 = computed({
            get() {
                return user.surnam + '_' + user.name;
            },
            set(val: string) {
                [user.surnam,user.name] = val.split('_');
            },
        });

        const fullName3 = ref('');
        // 监视
        // watch(user, ({surnam, name}) => {
        //     fullName3.value = surnam + '_' + name
        // }, { immediate: true, deep: true });

        // watchEffect(() => {
        //     fullName3.value = user.surnam + '_' + user.name
        // });

        // 监视fullName3的数据，user
        watchEffect(() => {
            [user.surnam,user.name] = fullName3.value.split('_');
        });

        // // watch--可以监听多个数据
        // watch([user.surnam,user.name],() => {
        //     // 这里的代码没有执行，因为 user.surnam,user.name 不是响应式的数据
        //     console.log('watch--可以监听多个数据');
        // })

        // 使用watch监视非响应式的数据
        watch([() => user.surnam,() => user.name],() => {
            console.log('watch--可以监听多个数据');
        })

        return {
            user,
            fullName1,
            fullName2,
            fullName3,
        }
    },
});
